var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Box, Button, Card, CardContent, Grid, InputAdornment, InputBase, MenuItem, Select, TextField, Typography, withStyles, } from "@material-ui/core";
import { useStyles } from "../CheckoutCard/CheckoutCardStyle";
import { Mail, User } from "react-feather";
import { useCheckoutTransferPseState } from "./state/useStateCheckoutTransferPse";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { Translate as T } from "react-localize-redux";
import { Controller } from "react-hook-form";
import InputMask from "react-input-mask";
import TermsConditions from "../commons/TermsConditions/TermsConditions";
import KPayCheck from "../commons/KPayCheck/KPayCheck";
import { defaultTo } from "lodash";
import { PERSON_TYPE } from "../../shared/constants/PersonType";
import { IdentificationNumberEnum } from "../../shared/constants/IdentificationNumberEnum";
import { useCheckoutContext } from "../../context/useCheckoutContext";
import Pse from "../../assets/logos/Pse";
var BootstrapInput = withStyles(function (theme) { return ({
    input: {
        "&:focus": {
            borderColor: theme.palette.info.main,
            borderRadius: 4,
            boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
        },
        backgroundColor: theme.palette.background.paper,
        border: "1px solid #ced4da",
        borderRadius: "4px",
        boxSizing: "border-box",
        color: "#6D7781",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 500,
        height: "48px",
        lineHeight: "140%",
        padding: "10px 5px 5px 10px",
        transition: theme.transitions.create(["border-color", "box-shadow"]),
    },
    root: {
        "label + &": {
            marginTop: theme.spacing(3),
        },
    },
}); })(InputBase);
export var CheckoutTransferPse = function () {
    var _a;
    var classes = useStyles();
    var _b = useCheckoutTransferPseState(), form = _b.form, handleKpayEnable = _b.handleKpayEnable, handleSubmit = _b.handleSubmit, bankList = _b.bankList, handleTermsModal = _b.handleTermsModal, termsModal = _b.termsModal, kpaySelected = _b.kpaySelected;
    var _c = useCheckoutContext(), amount = _c.amount, readOnly = _c.readOnly, emailKpay = _c.emailKpay, enableKpay = _c.enableKpay, buildPayButtonText = _c.buildPayButtonText, buildAmountText = _c.buildAmountText, disablePayButton = _c.disablePayButton;
    var bankDefault = bankList ? bankList[0].code : "";
    var dataKpaySelected = __assign({}, defaultTo(kpaySelected, {
        bankId: bankDefault,
        brand: "",
        documentNumber: "",
        documentType: IdentificationNumberEnum["Colombia"][0].value,
        email: "",
        id: "",
        kind: "transfer",
        name: "",
        userType: PERSON_TYPE[0].value,
    }));
    return (React.createElement("form", { onSubmit: form.handleSubmit(handleSubmit) },
        React.createElement(Card, { variant: "elevation", elevation: 0 },
            React.createElement(CardContent, null,
                React.createElement(Grid, { container: true, item: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Pse, null)),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Controller, { name: "bank", defaultValue: dataKpaySelected.bankId, control: form.control, rules: {
                                required: {
                                    message: (React.createElement(T, { id: "form.fieldRequired" })),
                                    value: true,
                                },
                            }, render: function (_a) {
                                var selectProps = __rest(_a, []);
                                return (React.createElement(Select, __assign({}, selectProps, { className: classes.selectType, fullWidth: true, value: !selectProps.value ? bankDefault : selectProps.value, input: React.createElement(BootstrapInput, null), error: form.errors["bank"] }), bankList === null || bankList === void 0 ? void 0 : bankList.map(function (item, index) { return (React.createElement(MenuItem, { value: item.code, key: index, className: classes.selectTitle }, item.name)); })));
                            } })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Box, { display: "flex", justifyContent: "center" },
                            React.createElement(Typography, { className: classes.typePerson, variant: "h6" },
                                React.createElement(T, { id: "pse.typePerson" })),
                            React.createElement(Controller, { name: "personType", defaultValue: dataKpaySelected.userType, render: function (_a) {
                                    var onChange = _a.onChange, value = _a.value;
                                    return (React.createElement(ToggleButtonGroup, { exclusive: true, "aria-label": "preview-options", value: value, onChange: function (_e, value) {
                                            return value !== null && onChange(value);
                                        } }, PERSON_TYPE.map(function (option, index) { return (React.createElement(ToggleButton, { className: classes.toggleBtn, key: "toggle-option-" + index, value: option.value, "aria-label": "preview-options" },
                                        React.createElement(Typography, { className: classes.textToggle },
                                            React.createElement(T, { id: option.label })))); })));
                                }, control: form.control }))),
                    !emailKpay && (React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(TextField, { fullWidth: true, "aria-current": true, name: "email", inputRef: form.register({
                                required: {
                                    message: (React.createElement(T, { id: "form.fieldRequired" })),
                                    value: true,
                                },
                            }), error: !!form.errors.email, helperText: !!form.errors["email"] && ((_a = form.errors["email"]) === null || _a === void 0 ? void 0 : _a.message), placeholder: "Email", InputProps: {
                                startAdornment: (React.createElement(InputAdornment, { position: "start" },
                                    React.createElement(Mail, { color: "#6D7781", size: 18 }))),
                            }, variant: "outlined" }))),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(TextField, { fullWidth: true, "aria-current": true, name: "name", defaultValue: dataKpaySelected.name, inputRef: form.register({
                                required: {
                                    message: (React.createElement(T, { id: "form.fieldRequired" })),
                                    value: true,
                                },
                            }), error: form.errors["name"], helperText: !!form.errors["name"] && form.errors["name"].message, variant: "outlined", placeholder: "Nombre", InputProps: {
                                className: classes.placeholder,
                                startAdornment: (React.createElement(InputAdornment, { position: "start" },
                                    React.createElement(User, { color: "#6D7781", size: 16 }))),
                            } })),
                    React.createElement(Grid, { item: true, xs: 3, md: 2 },
                        React.createElement(Controller, { name: "documentType", control: form.control, rules: {
                                required: {
                                    message: (React.createElement(T, { id: "form.fieldRequired" })),
                                    value: true,
                                },
                            }, defaultValue: dataKpaySelected.documentType, render: function (_a) {
                                var selectDTProps = __rest(_a, []);
                                return (React.createElement(Select, __assign({}, selectDTProps, { className: classes.selectType, fullWidth: true, input: React.createElement(BootstrapInput, null), error: form.errors["documentType"] }), IdentificationNumberEnum["Colombia"].map(function (item, index) { return (React.createElement(MenuItem, { value: item.value, key: index }, item.label)); })));
                            } })),
                    React.createElement(Grid, { item: true, xs: 9, md: 10 },
                        React.createElement(InputMask, { mask: "999999999999999", maskChar: null, defaultValue: dataKpaySelected.documentNumber }, function () { return (React.createElement(TextField, { fullWidth: true, "aria-current": true, name: "documentNumber", inputRef: form.register({
                                required: {
                                    message: (React.createElement(T, { id: "form.fieldRequired" })),
                                    value: true,
                                },
                            }), error: form.errors["documentNumber"], helperText: !!form.errors["documentNumber"] &&
                                form.errors["documentNumber"].message, variant: "outlined", placeholder: "Número de identificación" })); })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(TermsConditions, { form: form, open: termsModal, setOpenTerms: handleTermsModal })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Box, { display: "flex", justifyContent: "center" },
                            React.createElement(Button, { disabled: readOnly || disablePayButton, type: "submit", variant: "contained", fullWidth: true, color: "primary", className: classes.button },
                                buildPayButtonText("payButton"),
                                buildAmountText(amount.currency, amount.total)))),
                    enableKpay && (React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(KPayCheck, { handlerChange: handleKpayEnable, isChecked: false }))))))));
};
